import React from 'react'
import { useStateValue } from '../StateProvider';
import './RightBar.css'
function RightBar() {
    const [state, dispatch] = useStateValue();
    return (
        <div className="rightBar">
            <div className="vericalLineRightUp"></div>
                <div className="stages">
                    <p className={state.btn === 1 ? 'number number__light' : 'number'}>01</p>
                    <p className={state.btn === 2 ? 'number number__light' : 'number'}>02</p>
                    <p className={state.btn === 3 ? 'number number__light' : 'number'}>03</p>
                    <p className={state.btn === 4 ? 'number number__light' : 'number'}>04</p>
                    <p className={state.btn === 5 ? 'number number__light' : 'number'}>05</p>
                </div>
            <div className="vericalLineRightDown"></div>
        </div>
    )
}

export default RightBar
